import React from "react";
import { Fade } from "react-reveal";
import TrishaHiking1 from "../assets/images/TrishaHiking1.JPG";
import TrishaHiking from "../assets/images/TrishaHiking.JPG";
import TrishaHiking2 from "../assets/images/TrishaHiking2.JPG";
import TrishaDance1 from "../assets/images/TrishaDance1.jpg";
import TrishaDance from "../assets/images/TrishaDance.jpg";
import TrishaDance2 from "../assets/images/TrishaDance2.jpg";
import TrishaSkiing from "../assets/images/TrishaSkiing.JPG";
import TrishaSkiing1 from "../assets/images/TrishaSkiing1.JPG";
import TrishaSkiing2 from "../assets/images/TrishaSkiing2.jpg";
import TrishaTennis from "../assets/images/TrishaTennis.JPG";
import TrishaTennis1 from "../assets/images/TrishaTennis1.JPG";
import "./Page.scss";

const Interests = () => {
  return (
    <div className="page-container">
      <Fade bottom duration={1000} distance="20px">
        <div className="page-header">
          <h1 className="page-title">Interests</h1>
        </div>
      </Fade>
      
      <Fade bottom duration={1000} distance="20px" delay={200}>
        <div className="page-content">
          <div className="interests-grid">
            <div className="interest-card">
              <h2>Nature Hiking</h2>
              <div className="photo-stack">
                <div className="photo-stack-item photo-1">
                  <img src={TrishaHiking1} alt="Trisha Hiking 1" />
                </div>
                <div className="photo-stack-item photo-2">
                  <img src={TrishaHiking} alt="Trisha Hiking" />
                </div>
                <div className="photo-stack-item photo-3">
                  <img src={TrishaHiking2} alt="Trisha Hiking 2" />
                </div>
              </div>
            </div>
            
            <div className="interest-card">
              <h2>Bollywood Dancing</h2>
              <div className="photo-stack">
                <div className="photo-stack-item photo-1">
                  <img src={TrishaDance1} alt="Trisha Dancing 1" />
                </div>
                <div className="photo-stack-item photo-2">
                  <img src={TrishaDance} alt="Trisha Dancing" />
                </div>
                <div className="photo-stack-item photo-3">
                  <img src={TrishaDance2} alt="Trisha Dancing 2" />
                </div>
              </div>
            </div>
            
            <div className="interest-card">
              <h2>Skiing</h2>
              <div className="photo-stack">
                <div className="photo-stack-item photo-1">
                  <img src={TrishaSkiing} alt="Trisha Skiing" />
                </div>
                <div className="photo-stack-item photo-2">
                  <img src={TrishaSkiing1} alt="Trisha Skiing 1" />
                </div>
                <div className="photo-stack-item photo-3">
                  <img src={TrishaSkiing2} alt="Trisha Skiing 2" />
                </div>
              </div>
            </div>
            
            <div className="interest-card">
              <h2>Tennis</h2>
              <div className="photo-stack">
                <div className="photo-stack-item photo-1">
                  <img src={TrishaTennis} alt="Trisha Tennis" />
                </div>
                <div className="photo-stack-item photo-2">
                  <img src={TrishaTennis1} alt="Trisha Tennis 1" />
                </div>
                <div className="photo-stack-item photo-3">
                  <div className="placeholder-image">Photo 3</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default Interests;

